import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { Hospital } from '@/types/_'
import Apis from '@/Apis/_'

interface Log {
  message: string | null,
  timeStamp: string | null,
  error: string | null,
}

@Module({ namespaced: true, name: 'SuporteConvitesStore' })
export default class SuporteProcedimentosApenasHospitalDiaStore extends VuexModule {
  public hospitais: Hospital[] = []
  public hospitalId: string = ''

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  csv: any = {}
  logs: Log[] = []

  @Mutation
  setCsv(value: any) {
    this.csv = value
  }

  @Mutation
  clearCsv() {
    this.csv = {}
  }

  @Mutation
  setLogs(value: Log[]) {
    this.logs = value
  }

  @Mutation
  clearLogs() {
    this.logs = []
  }

  @Action
  async importListaDeSecretariasCsv() {
    try {
      const request = await Apis.Cadastro.CadastroApi.importListaDeSecretariasCsv(this.hospitalId, this.csv)
      if (request.success && request.data.value) this.context.commit('setLogs', request.data.value.cargaConviteMedico as Log[] || [])
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
